/**
 * API service for 施術師毎CSV出力 (SCR-046).
 * Endpoints under /rezepts/massager-csv/.
 */

import { apiClient } from '@/shared/lib/axios';
import { clinicApiPath } from '@/shared/lib/apiPath';
import { SERVICE_TYPE_A2 } from '@/constants/serviceType';
import type {
  MassagerCsvSearchParams,
  MassagerCsvSearchResponse,
  MassagerCsvMassagersResponse,
  MassagerCsvExportPayload,
} from '@/pages/main/massagerCsv/types';

function toParams(
  filters: MassagerCsvSearchParams
): Record<string, string | number> {
  const params: Record<string, string | number> = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params[key] = value as string | number;
    }
  });
  return params;
}

/**
 * Search rezepts for the massager CSV list.
 */
export async function searchMassagerCsv(
  siteType: string,
  clinicNumber: string,
  filters: MassagerCsvSearchParams,
  serviceType: string = SERVICE_TYPE_A2
): Promise<MassagerCsvSearchResponse> {
  const response = await apiClient.get<MassagerCsvSearchResponse>(
    clinicApiPath(siteType, clinicNumber, '/rezepts/massager-csv/search'),
    {
      params: toParams(filters),
      headers: { 'X-Service-Type': serviceType },
    }
  );
  return response.data;
}

/**
 * Get massager dropdown options for the given visit month.
 */
export async function getMassagerCsvMassagers(
  siteType: string,
  clinicNumber: string,
  searchVisitmonth: string,
  serviceType: string = SERVICE_TYPE_A2
): Promise<MassagerCsvMassagersResponse> {
  const response = await apiClient.get<MassagerCsvMassagersResponse>(
    clinicApiPath(siteType, clinicNumber, '/rezepts/massager-csv/massagers'),
    {
      params: { search_visitmonth: searchVisitmonth },
      headers: { 'X-Service-Type': serviceType },
    }
  );
  return response.data;
}

/**
 * Export CSV file (returns Blob for download).
 */
export async function exportMassagerCsv(
  siteType: string,
  clinicNumber: string,
  payload: MassagerCsvExportPayload,
  serviceType: string = SERVICE_TYPE_A2
): Promise<Blob> {
  const response = await apiClient.post(
    clinicApiPath(siteType, clinicNumber, '/rezepts/massager-csv/export-csv'),
    payload,
    {
      responseType: 'blob',
      headers: { 'X-Service-Type': serviceType },
    }
  );
  return response.data as Blob;
}
